// extracted by mini-css-extract-plugin
module.exports = {"hero":"index-module--hero--bkF3e","heroImage":"index-module--heroImage--3U_ja","heroOverlay":"index-module--heroOverlay--2z2Wa","categories":"index-module--categories--j9Ul1"};